"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayOneSMAMetricNames = void 0;
var DayOneSMAMetricNames;
(function (DayOneSMAMetricNames) {
    DayOneSMAMetricNames["DAY_ONE_WIDGET_API_ERROR"] = "day_one_widget.api_error";
    DayOneSMAMetricNames["DAY_ONE_WIDGET_DATA_ERROR"] = "day_one_widget.data_error";
})(DayOneSMAMetricNames = exports.DayOneSMAMetricNames || (exports.DayOneSMAMetricNames = {}));
//# sourceMappingURL=DayOneIngressWidgetTypes.js.map